// New modular draft system adapter. Keeps the same exported API for compatibility.

import type { DraftData } from '@/drafts/DraftTypes';
import { draftService } from '@/drafts/DraftService';

export type { DraftData };

class LocalDraftServiceAdapter {
  generateDraftId(): string { return draftService.generateDraftId(); }
  listDrafts(): DraftData[] { return draftService.listDrafts(); }
  getDraft(id: string): DraftData | null { return draftService.getDraft(id); }
  createDraft(name: string): DraftData { return draftService.createDraft(name); }
  saveDraft(draftData: DraftData): void { return draftService.saveDraft(draftData); }
  deleteDraft(id: string): void { return draftService.deleteDraft(id); }
  getCurrentDraftId(): string | null { return draftService.getCurrentDraftId(); }
  setCurrentDraftId(id: string): void { return draftService.setCurrentDraftId(id); }
  clearCurrentDraftId(): void { /* not used externally; clear via clearAllCampaignData */ }
  collectCurrentCampaignData(): Partial<DraftData> { return draftService.collectCurrentCampaignData(); }
  loadDraftData(draftId: string): boolean { return draftService.loadDraftData(draftId); }
  clearAllCampaignData(): void { return draftService.clearAllCampaignData(); }
}

export const localDraftService = new LocalDraftServiceAdapter();
